import React from 'react'
import propTypes from 'prop-types';
import { SpinnerPrimary, SpinnerSecondary } from '../../../theme/icons';

export const Buttons = React.memo(({ text, icon, iconPos, disabled, onClick, loader, variant, className, loaderText, loaderVariant, type, tabIndex, role, loaderClassName = "w-4 h-4 max-w-4 min-w-4 ", ...rest }) => {
   
    const variants = {
        'primary': 'btn btn-primary h-fit',
        'secondary': 'btn btn-secondary h-fit',
        'success': 'btn btn-success h-fit',
        'danger': 'btn btn-danger h-fit',
        'warning': 'btn btn-warning h-fit',
        'info': 'btn btn-info h-fit',
        'tertiary': 'btn btn-tertiary h-fit',
        'google': 'flex items-center justify-between font-12 border p-2 rounded-md border-google-50 gap-2 h-fit'
    }

    const getLoaderText = loader ? loaderText : text;
 

    const Spinner = () => loaderVariant === 'primary' ? <SpinnerPrimary className={loaderClassName}  /> : <SpinnerSecondary className={loaderClassName} />

    const LeftPositionedIcon = () => <> {loader ? <Spinner /> : icon} {getLoaderText ? <span>{getLoaderText}</span> : ''} </>

    const RightPositionedIcon = () => <><span>{getLoaderText}</span>{loader ? <Spinner /> : icon}</>

    const getButtonTitle = () => (iconPos === "l" && icon) ? <LeftPositionedIcon /> : (iconPos === "r" && icon) ? <RightPositionedIcon /> : getLoaderText

    return (<>
        <button aria-label={text} {...rest} role={role} className={`${variants[variant]} ${className}`} tabIndex={tabIndex} onClick={onClick} disabled={disabled} type={type}>
            {getButtonTitle()}
        </button>
    </>

    )
})

// You can declare that a prop is a specific JS type. By default, these
// are all optional.
Buttons.propTypes = {
    text: propTypes.string,
    icon: propTypes.node,
    iconPos: propTypes.string,
    disabled: propTypes.bool,
    onClick: propTypes.func,
    loader: propTypes.bool,
    variant: propTypes.string,
    className: propTypes.string,
    loaderText: propTypes.string,
    type: propTypes.string,
    tabIndex: propTypes.string,
    loaderVariant: propTypes.string,
    role: propTypes.string,
    loaderClassName: propTypes.string,
}

// Specifies the default values for props:
Buttons.defaultProps = {
    text: 'Default button text',
    icon: <></>,
    iconPos: "l",  /* l - left , r - right      */
    disabled: false,
    loader: false,
    variant: "primary",
    className: "",
    loaderText: "Loading...",
    onClick: () => { },
    type: "button",
    tabIndex: '0',
    loaderVariant: 'primary',
    role: 'button',
     
};